import { render, staticRenderFns } from "./ShoppingCheck.vue?vue&type=template&id=18688d22"
import script from "./ShoppingCheck.vue?vue&type=script&lang=js"
export * from "./ShoppingCheck.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCheck.vue?vue&type=style&index=0&id=18688d22&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports